import { memo, useMemo, useState } from 'react'
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Typography,
  Theme,
} from '@mui/material'
import { makeStyles, createStyles } from '@mui/styles'

import BankListItem from './BankListItem'
import { IBankListComponentProps } from './typings'
import BankItemProductDetails from './product-details'

const useStyles = makeStyles<Theme>((theme: Theme) =>
  createStyles({
    banklistContainer: {
      padding: '22px 26px 32px 26px',
      maxWidth: 1200,
      margin: '0px auto',
      [theme.breakpoints.down('md')]: {
        padding: '22px 10px',
      },
    },
    microText: {
      fontSize: 12,
      margin: '12px 10px 24px 10px',
      fontWeight: 400,
      color: 'rgb(50, 50, 50)',
      textAlign: 'inherit',
      WebkitFontSmoothing: 'antialiased',
    },
    accordionCls: {
      pointerEvents: 'none',
      '&:before': {
        backgroundColor: 'transparent !important',
        boxShadow: 'none',
      },
    },
    accordionSummaryCls: {
      padding: 0,
      height: '120px',
      [theme.breakpoints.down('md')]: {
        height: '300px',
      },
      [theme.breakpoints.down('sm')]: {
        height: '315px',
      },
    },
    accordionDetailsCls: {
      border: '1px solid',
      borderTop: 'none',
      borderColor: theme.palette.grey[400],
      borderRadius: '0px 0px 5px 5px',
      padding: 0,
      height: 'calc(100% + 10px)',
    },
  }),
)

const BankListComponent = ({ bankList }: IBankListComponentProps) => {
  const mapping: { [x: string]: boolean } = useMemo(() => {
    const mappingObj = {}
    bankList.forEach((item) => ({
      ...mappingObj,
      [`${item.product.id}`]: false,
    }))
    return mappingObj
  }, [bankList])
  const [isExpandedArray, setExpandedArray] = useState(mapping)
  const handleExpand = (panelName: string) => {
    setExpandedArray({
      ...isExpandedArray,
      [panelName]: !isExpandedArray[panelName],
    })
  }
  const {
    banklistContainer,
    microText,
    accordionCls,
    accordionSummaryCls,
    accordionDetailsCls,
  } = useStyles()

  return (
    <div className={banklistContainer} id='banklist-container'>
      {bankList.map((bankListItem) => (
        <div key={bankListItem.product.id}>
          <Accordion
            expanded={isExpandedArray[`${bankListItem.product.id}`]}
            elevation={0}
            disableGutters
            className={accordionCls}
          >
            <AccordionSummary className={accordionSummaryCls}>
              <BankListItem
                key={bankListItem.product.id}
                bankListItem={bankListItem}
                expandHandler={handleExpand}
                isRowExpanded={isExpandedArray[`${bankListItem.product.id}`]}
              />
            </AccordionSummary>
            <AccordionDetails className={accordionDetailsCls}>
              <BankItemProductDetails
                bank={bankListItem.product.bank}
                images={bankListItem.product.images}
                features={bankListItem.product.features}
                conditions={bankListItem.product.conditions}
              />
            </AccordionDetails>
          </Accordion>
          <Typography className={microText}>
            {bankListItem.calculation.legalText}
          </Typography>
        </div>
      ))}
    </div>
  )
}

export default memo(BankListComponent)
